export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-confirm/index.js